<template>
  <div
    class="hover:bg-gray-100 cursor-pointer px-3 py-1 rounded-md"
    :data-test="data_test"
  >
    <slot />
  </div>
</template>

<script setup>
import 'vue';

defineProps({
  data_test: { type: String, default: '' },
});
</script>
